module.exports = __webpack_public_path__ + "static/img/bb.db45224.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/bb.png
// module id = ikGB
// module chunks = 0